export default __webpack_public_path__ + "static/media/Interactive Map.065eeb55.svg";